import { http } from '@pendo/http';
import { getAppDisplayName } from '@/utils/apps';

export const inviteConfirmationErrors = Object.freeze({
    INVALID: 'invalid invitation data',
    EXPIRED: 'invitation expired',
    KEY_ISSUE: 'invalid invitation key',
});

export function fetchUser () {
    const inFlightUserPromise = window.__userPromise;

    if (inFlightUserPromise) {
        window.__userPromise = null;

        return inFlightUserPromise.then((userData) => {
            if (userData) {
                return transformInitResponse(userData);
            }

            return http.get('/api/init').then((res) => transformInitResponse(res.data));
        });
    }

    return http.get('/api/init').then((res) => transformInitResponse(res.data));
}

function transformInitResponse (data) {
    const isAEUSubscription = data?.activeSubscription?.productLines?.find((pl) => pl.type === 'adoptEndUser' && pl.purchased);
    if (!isAEUSubscription) {
        return data;
    }

    try {
        return initAEUSubscription({ data });
    } catch {
        return data;
    }
}

export function initAEUSubscription (res) {
    return {
        ...res.data,
        activeSubscription: {
            ...res.data.activeSubscription,
            applications: res.data.activeSubscription.applications.map((app) => {
                return {
                    ...app,
                    displayName: getAppDisplayName(app),
                };
            }),
        },
        subscriptions: res.data.subscriptions.map((sub) => {
            return {
                ...sub,
                applications: sub.applications ? sub.applications.map((app) => {
                    return {
                        ...app,
                        displayName: getAppDisplayName(app),
                    };
                }) : undefined,
            };
        }),
    };
}

export function fetchUserDetails (uid) {
    return http.get(`/api/s/_SID_/user/${uid}`).then((res) => res.data);
}

export function getAuthType (username) {
    return http.get(`/login/resolveauth?username=${encodeURIComponent(username)}`).then((res) => res.data);
}

export function login (username, password, queryString) {
    return http.post(`/login${queryString}`, { username, password }).then((res) => res.data);
}

export function logout () {
    return http.post('/logout');
}

export function updateActiveSubscription (subId) {
    return http.put(`/api/user/_UID_/setsubscription/${subId}`);
}

export function update (user) {
    return http.put(`/api/s/_SID_/user/${user.id}`, user).then((res) => res.data);
}

export function updateEmail (newEmail, currentEmail) {
    return http.put('/api/s/_SID_/user/_UID_/email', { newEmail, currentEmail }).then((res) => res.data);
}

export function updateUsername (newUsername, password) {
    return http.put('/api/s/_SID_/user/_UID_/username', { newUsername, password }).then((res) => res.data);
}

export function updatePassword (oldPass, newPass) {
    return http.put('/api/s/_SID_/user/_UID_/password', { old: oldPass, new: newPass }).then((res) => res.data);
}

export function confirmInvitation (inviteKey) {
    return http.get(`/api/signup/invitation/confirm/${inviteKey}`);
}

export function fetchUnauthenticatedTrainingAttributes () {
    return http.get('/whitelabelsettings').then((res) => res.data);
}
